import "@styles/vendors.scss";
import 'photoswipe/style.css';

import { Splide } from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
window["Splide"] = Splide;
window["AutoScroll"] = AutoScroll;

import PhotoSwipeLightbox from 'photoswipe/lightbox';
// import PhotoSwipe from 'photoswipe';

window["PhotoSwipeLightbox"] = PhotoSwipeLightbox;
// window["PhotoSwipe"] = PhotoSwipe;


